/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_GInputs */

const en_tut_inbox_g = /** @type {(inputs: Tut_Inbox_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The inbox collects whatever mentions you or waits on you, so nothing gets lost between channels and issues.`)
};

const id_tut_inbox_g = /** @type {(inputs: Tut_Inbox_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox mengumpulkan hal yang menyebut atau menunggu Anda, supaya tidak ada yang hilang di antara channel dan issue.`)
};

/**
* | output |
* | --- |
* | "The inbox collects whatever mentions you or waits on you, so nothing gets lost between channels and issues." |
*
* @param {Tut_Inbox_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_g = /** @type {((inputs?: Tut_Inbox_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_g(inputs)
	return en_tut_inbox_g(inputs)
});